export default __webpack_public_path__ + "static/media/container_tracking-yellow.b8f85998.svg";